(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8780],{

/***/ 38780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72006);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56399);
/* harmony import */ var _SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67754);
/* harmony import */ var _SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99585);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32033);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39181);
/* harmony import */ var _BackgroundCircle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22462);









var SimpleSection = function(param) {
    var data = param.data;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), displayedText = ref1[0], setDisplayedText = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFullText = ref2[0], setShowFullText = ref2[1];
    // Define text segments with their types
    var segments = [
        {
            text: "We provide ",
            type: "normal"
        },
        {
            text: "cross-platform frameworks",
            type: "highlight"
        },
        {
            text: " for building \uD83D\uDD25 ",
            type: "normal"
        },
        {
            text: "high-performance, ",
            type: "normal"
        },
        {
            text: "GPU-accelerated",
            type: "highlight"
        },
        {
            text: " video plugins. Target ",
            type: "normal"
        },
        {
            text: "Adobe Premiere",
            type: "highlight"
        },
        {
            text: " ",
            type: "image",
            src: "/logo/Adobe_Premiere_Pro.svg",
            alt: "Adobe Premiere Pro",
            className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().adobeIcon)
        },
        {
            text: " and ",
            type: "normal"
        },
        {
            text: "DaVinci Resolve",
            type: "highlight"
        },
        {
            text: " ",
            type: "image",
            src: "/logo/DaVinci_Resolve_Studio.svg",
            alt: "DaVinci Resolve Studio",
            className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().davinciIcon)
        },
        {
            text: ", ",
            type: "normal"
        },
        {
            text: "Final Cut Pro",
            type: "highlight"
        },
        {
            text: " ",
            type: "image",
            src: "/logo/Final_Cut_Pro.svg",
            alt: "Final Cut Pro",
            className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().finalCutIcon)
        },
        {
            text: " and ",
            type: "normal"
        },
        {
            text: "many others",
            type: "highlight"
        },
        {
            text: " with a simplified API for GPU operations and ",
            type: "normal"
        },
        {
            text: "plugin creation",
            type: "highlight"
        },
        {
            text: ".",
            type: "normal"
        }, 
    ];
    // Calculate fullText from segments
    var fullText = segments.map(function(seg) {
        return seg.text;
    }).join("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (showFullText) {
            setDisplayedText(fullText);
            return;
        }
        var currentIndex = 0;
        var typingInterval = setInterval(function() {
            if (currentIndex <= fullText.length) {
                setDisplayedText(fullText.substring(0, currentIndex));
                currentIndex++;
            } else {
                clearInterval(typingInterval);
                setShowFullText(true);
            }
        }, 70); // Speed of typing (adjust as needed)
        return function() {
            return clearInterval(typingInterval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Helper function to render text with highlights
    var renderTypedText = function() {
        // Calculate cumulative lengths
        var currentLength = 0;
        var segmentRanges = segments.map(function(seg) {
            var range = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                start: currentLength,
                end: currentLength + seg.text.length
            }, seg);
            currentLength += seg.text.length;
            return range;
        });
        // Render based on current displayedText length
        var renderedParts = [];
        segmentRanges.forEach(function(range) {
            if (range.end <= displayedText.length) {
                // Fully typed segment
                if (range.type === "normal") {
                    renderedParts.push(range.text);
                } else if (range.type === "highlight") {
                    renderedParts.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().highlight),
                        children: range.text
                    }, renderedParts.length));
                } else if (range.type === "image") {
                    renderedParts.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: range.src,
                        alt: range.alt,
                        className: range.className
                    }, renderedParts.length));
                }
            } else if (range.start < displayedText.length) {
                // Partially typed segment
                var partialLength = displayedText.length - range.start;
                if (range.type === "normal") {
                    renderedParts.push(range.text.substring(0, partialLength));
                } else if (range.type === "highlight") {
                    renderedParts.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().highlight),
                        children: range.text.substring(0, partialLength)
                    }, renderedParts.length));
                }
            }
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainTextContent),
            children: [
                renderedParts,
                showFullText && " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cursor),
                    children: "|"
                })
            ]
        });
    };
    var msgSection = data === null || data === void 0 ? void 0 : (ref = data.components) === null || ref === void 0 ? void 0 : ref.find(function(comp) {
        return comp.name === "msg_section";
    });
    var handleScroll = function() {
        react_scroll__WEBPACK_IMPORTED_MODULE_2__/* .scroller.scrollTo */ .OK.scrollTo("product", {
            duration: 200,
            delay: 0,
            smooth: "easeInOutCubic",
            offset: -100
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().simpleSectionWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().simpleSection),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackgroundCircle__WEBPACK_IMPORTED_MODULE_5__/* .BackgroundCircle */ .K, {
                    bottom: "30px",
                    left: "-170px",
                    width: "400px",
                    height: "400px",
                    animation: "glow",
                    style: {
                        zIndex: 1
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackgroundCircle__WEBPACK_IMPORTED_MODULE_5__/* .BackgroundCircle */ .K, {
                    top: "30px",
                    right: "-85px",
                    width: "400px",
                    height: "400px",
                    animation: "float",
                    animationDelay: "1s",
                    style: {
                        zIndex: 1
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_8__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 800,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                variant: "display-lg",
                                as: "h2",
                                className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainText),
                                color: "light-primary",
                                weight: "medium",
                                align: "center",
                                children: renderTypedText()
                            })
                        }),
                        !!(msgSection === null || msgSection === void 0 ? void 0 : msgSection.CTA_text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_8__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 800,
                            delay: 400,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonContainer),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                        size: "lg",
                                        onClick: handleScroll,
                                        className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().primaryButton),
                                        children: msgSection.CTA_text
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                        variant: "secondary",
                                        size: "lg",
                                        onClick: handleScroll,
                                        className: (_SimpleSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondaryButton),
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M5.83398 10.8333L10.0007 15L14.1673 10.8333M5.83398 5L10.0007 9.16667L14.1673 5",
                                                stroke: "currentColor",
                                                strokeWidth: "1.66667",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        iconPosition: "right",
                                        children: "Explore Products"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SimpleSection);


/***/ }),

/***/ 67754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"simpleSectionWrapper":"SimpleSection_simpleSectionWrapper__Pf8KC","simpleSection":"SimpleSection_simpleSection__G2tyh","content":"SimpleSection_content__fjml5","mainTextContent":"SimpleSection_mainTextContent__s86Bh","highlight":"SimpleSection_highlight__x0sIP","adobeIcon":"SimpleSection_adobeIcon__HKX7V","davinciIcon":"SimpleSection_davinciIcon__GLtmQ","finalCutIcon":"SimpleSection_finalCutIcon__uJams","cursor":"SimpleSection_cursor__oeSAn","blink":"SimpleSection_blink__gZeV4","buttonContainer":"SimpleSection_buttonContainer__tE1Wg"};

/***/ })

}]);